// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"180fbd2a","117":"7253f497","249":"be06cce6","386":"95d02596","458":"180fbd2a","502":"14bf0e2f","705":"872deb81","716":"ba1f67ac","818":"74ee4632","897":"180fbd2a","924":"0fada7f1","937":"71145bf3"}[chunkId] + ".chunk.css";
};